import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getClients } from 'src/module/admin/selector';
import { fetchClients } from 'src/module/admin/action';
import UsersList from 'src/component/UsersList';
import AutoCompleteSelect from 'src/component/UI/AutoCompleteSelect';
import { useTranslation } from 'src/i18n';

export default function AdministratorUserScreen () {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const clients = useSelector(getClients);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [clientValue, setClientValue] = useState(null);
  const selectedClient = clients.find((c) => c.get('id') === selectedClientId);

  const clientData = clients?.reduce((acc, client) => {
    acc.push({ label: client.get('name', 'N/A'), value: client.get('id') });
    return acc;
  }, []);

  useEffect(() => {
    dispatch(fetchClients());
  }, []);

  const handleChangeClient = (obj) => {
    setSelectedClientId(obj?.value ?? null);
    const client = clients.find((c) => c.get('id') === obj?.value);
    const clientName = client?.get('name') ?? 'N/A';
    if (obj?.value) {
      setClientValue({ label: clientName, obj: obj?.value });
    }
    else {
      setClientValue(null);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, padding: '10px' }}>
      <Paper>
        <h2>{t('admin.users')}</h2>
        <div style={{ width: '250px', float: 'right', marginBottom: '30px' }}>
          <AutoCompleteSelect
            onChangeFn={handleChangeClient}
            options={clientData}
            id='clients-select'
            initialValues={clientValue}
            placeholder={t('admin.selectClient')}
            disableBlur
          />
        </div>
        <UsersList client={selectedClient} showSupportUsers />
      </Paper>
    </Box>
  );
}


AdministratorUserScreen.propTypes = {
  match: PropTypes.object
};

AdministratorUserScreen.defaultProps = {};
